import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { BookOpen } from 'lucide-react';
import toast from 'react-hot-toast';
import api from '../../api/client';

export default function OpacLoginPage() {
  const [form, setForm] = useState({ username:'', password:'' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post('/auth/login', form);
      localStorage.setItem('opac_token', data.token);
      localStorage.setItem('opac_user', JSON.stringify(data.user));
      window.location.href = '/opac/my';
    } catch {
      toast.error('არასწორი მომხმარებელი ან პაროლი');
    } finally { setLoading(false); }
  };

  return (
    <div style={{minHeight:'70vh',display:'flex',alignItems:'center',justifyContent:'center',padding:24}}>
      <div style={{width:'100%',maxWidth:380}}>
        <div style={{textAlign:'center',marginBottom:32}}>
          <BookOpen size={40} style={{color:'#60a5fa',margin:'0 auto 12px',display:'block'}} />
          <h1 style={{fontSize:22,fontWeight:700,color:'#f1f5f9',margin:'0 0 6px'}}>შესვლა</h1>
          <p style={{fontSize:13,color:'#475569'}}>ბიბლიოთეკის პირადი ანგარიში</p>
        </div>
        <div style={{background:'#0d1424',border:'1px solid #1e2d45',borderRadius:12,padding:24}}>
          <form onSubmit={handleSubmit}>
            <div style={{marginBottom:14}}>
              <label style={{display:'block',fontSize:12,color:'#64748b',marginBottom:6}}>მომხმარებელი</label>
              <input value={form.username} onChange={e => setForm(f => ({...f,username:e.target.value}))} required
                style={{width:'100%',background:'#080c14',border:'1px solid #1e2d45',borderRadius:8,padding:'10px 12px',fontSize:13,color:'#e2e8f0',outline:'none',boxSizing:'border-box'}} />
            </div>
            <div style={{marginBottom:20}}>
              <label style={{display:'block',fontSize:12,color:'#64748b',marginBottom:6}}>პაროლი</label>
              <input type="password" value={form.password} onChange={e => setForm(f => ({...f,password:e.target.value}))} required
                style={{width:'100%',background:'#080c14',border:'1px solid #1e2d45',borderRadius:8,padding:'10px 12px',fontSize:13,color:'#e2e8f0',outline:'none',boxSizing:'border-box'}} />
            </div>
            <button type="submit" disabled={loading}
              style={{width:'100%',background:'#1d4ed8',border:'none',borderRadius:8,padding:11,fontSize:14,fontWeight:500,color:'white',cursor:'pointer',opacity:loading?0.6:1}}>
              {loading ? 'შესვლა...' : 'შესვლა'}
            </button>
          </form>
        </div>
        <p style={{textAlign:'center',marginTop:16,fontSize:13,color:'#475569'}}>
          <Link to="/opac" style={{color:'#60a5fa',textDecoration:'none'}}>← კატალოგი</Link>
        </p>
      </div>
    </div>
  );
}
